import http from '../../store/services/http-common';
import { isAuthenticated } from '../../utilities/authentication';
import { dedupeRequest } from '../requestDeduper';
import { queryKeys } from '../queryKeys';

export async function fetchUnreadNotificationCount() {
  if (!isAuthenticated()) {
    return 0;
  }

  return dedupeRequest(queryKeys.notifications.unreadCount().join(':'), async () => {
    const { data } = await http.get('/notifications/unread-count');
    return Number(data?.data?.unread_count ?? 0);
  });
}

export async function fetchNotificationsList(perPage = 10, page = 1) {
  if (!isAuthenticated()) {
    return {
      items: [],
      unreadCount: 0,
      currentPage: 1,
      lastPage: 1,
      perPage,
      total: 0,
    };
  }

  const { data } = await http.get('/notifications', {
    params: { per_page: perPage, page },
  });
  const meta = data?.meta ?? {};

  return {
    items: Array.isArray(data?.data) ? data.data : [],
    unreadCount: typeof meta.unread_count === 'number' ? meta.unread_count : undefined,
    currentPage: Number(meta.current_page) || page,
    lastPage: Number(meta.last_page) || 1,
    perPage: Number(meta.per_page) || perPage,
    total: Number(meta.total) || 0,
  };
}

export const NOTIFICATIONS_POLL_MS = 30000;
export const NOTIFICATIONS_BELL_LIMIT = 10;
export const NOTIFICATIONS_PAGE_SIZE = 10;

export function unreadCountQueryOptions() {
  return {
    queryKey: queryKeys.notifications.unreadCount(),
    queryFn: fetchUnreadNotificationCount,
    staleTime: NOTIFICATIONS_POLL_MS,
    refetchInterval: NOTIFICATIONS_POLL_MS,
    enabled: isAuthenticated(),
  };
}

export function notificationsListQueryOptions(perPage = 10, page = 1, enabled = false) {
  return {
    queryKey: queryKeys.notifications.list(perPage, page),
    queryFn: () => fetchNotificationsList(perPage, page),
    staleTime: 30 * 1000,
    enabled: enabled && isAuthenticated(),
  };
}
